module.exports = __webpack_public_path__ + "img/Build-your-home-amico-light-blue.bec2745c.png";